import { render } from "./EsseGroupLogo.vue?vue&type=template&id=270f25f3&lang=pug"
const script = {}

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__